import { FC } from 'react'
import { SubAccountInfo } from '../../store/userEditorData/types'
import Checkbox from '../Checkbox'

interface Props {
  subAccounts: SubAccountInfo[]
  enabledIds: number[]
  defaultId: number | undefined
  onToggle: (custId: number) => void
  onSetDefault: (custId: number) => void
}

const SubAccountEditor: FC<Props> = ({
  subAccounts,
  enabledIds,
  defaultId,
  onToggle,
  onSetDefault
}) => {
  return (
    <div>
      <table>
        <thead>
          <tr>
            <td>Sub-Account</td>
            <td>Enabled</td>
            <td>Default</td>
          </tr>
        </thead>
        <tbody>
          {subAccounts.map((sa) => (
            <tr key={sa.custId}>
              <td>
                {sa.custName} : {sa.description} {sa.custId}
              </td>
              <td>
                <Checkbox
                  locator={`subAccount-enabled-${sa.custId}`}
                  checked={enabledIds.includes(sa.custId)}
                  onChange={() => onToggle(sa.custId)}
                />
              </td>
              <td>
                <Checkbox
                  locator={`subAccount-default-${sa.custId}`}
                  checked={defaultId === sa.custId}
                  onChange={() => onSetDefault(sa.custId)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default SubAccountEditor
